/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetCheckoutFullfillmentStockings200ResponseAllOfData } from './GetCheckoutFullfillmentStockings200ResponseAllOfData';
import {
    GetCheckoutFullfillmentStockings200ResponseAllOfDataFromJSON,
    GetCheckoutFullfillmentStockings200ResponseAllOfDataFromJSONTyped,
    GetCheckoutFullfillmentStockings200ResponseAllOfDataToJSON,
} from './GetCheckoutFullfillmentStockings200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetCheckoutFullfillmentStockings200Response
 */
export interface GetCheckoutFullfillmentStockings200Response {
    /**
     * 
     * @type {GetCheckoutFullfillmentStockings200ResponseAllOfData}
     * @memberof GetCheckoutFullfillmentStockings200Response
     */
    data: GetCheckoutFullfillmentStockings200ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof GetCheckoutFullfillmentStockings200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the GetCheckoutFullfillmentStockings200Response interface.
 */
export function instanceOfGetCheckoutFullfillmentStockings200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function GetCheckoutFullfillmentStockings200ResponseFromJSON(json: any): GetCheckoutFullfillmentStockings200Response {
    return GetCheckoutFullfillmentStockings200ResponseFromJSONTyped(json, false);
}

export function GetCheckoutFullfillmentStockings200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCheckoutFullfillmentStockings200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetCheckoutFullfillmentStockings200ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function GetCheckoutFullfillmentStockings200ResponseToJSON(value?: GetCheckoutFullfillmentStockings200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetCheckoutFullfillmentStockings200ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

